module.exports = __webpack_public_path__ + "img/bling-holo.3248c37.webp";